import React, { useContext, useEffect, useState } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import CustomTextArea from "../../Components/Reusable/CustomTextArea";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import HomeSliderService from "../../Services/HomeSliderService";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../Context/authContext";

const UpdateSlider = () => {
    const [sliderData, setSliderData] = useState({});
    const [Sliderdataedit, setTestimonialEdit] = useState({ ...useLocation().state });
    const {user}=useContext(AuthContext)

    const Validations = yup.object().shape({
        // uploadimageone: validationRegex.required,
        // sliderTwoImage: validationRegex.required,
        // sliderThreeImage: validationRegex.required,
        sliderOneLink: validationRegex.required,
        sliderOneTitle: validationRegex.required,
        sliderOneDescription:validationRegex.required,
        sliderOneButtonTitle:validationRegex.required,
        sliderTwoLink:validationRegex.required,
        sliderTwoTitle: validationRegex.required,
        sliderTwoDescription: validationRegex.required,
        sliderTwoButtonTitle: validationRegex.required,
        sliderThreeLink:validationRegex.required,
        sliderThreeTitle: validationRegex.required,
        sliderThreeDescription: validationRegex.required,
        sliderThreeButtonTitle: validationRegex.required,

        // uploadimagedesktopone: validationRegex.required,
        // uploadimagemobileone: validationRegex.required,
        // uploadimagedesktoptwo: validationRegex.required,
        // uploadimagemobiletwo: validationRegex.required,
        // uploadimagedesktopthree: validationRegex.required,
        // uploadimagemobilethree: validationRegex.required,
    });
    const {
        register,
        handleSubmit,
        setValue,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            sliderOneLink: Sliderdataedit?.sliderOneLink || "",
            sliderOneButtonTitle: Sliderdataedit?.sliderOneButtonTitle || "",
            sliderOneDescription: Sliderdataedit?.sliderOneDescription || "",
            sliderOneTitle: Sliderdataedit?.sliderOneTitle || "",
            sliderOneImage: Sliderdataedit?.sliderOneImage || "",
            sliderTwoLink: Sliderdataedit?.sliderTwoLink || "",
            sliderTwoDescription: Sliderdataedit?.sliderTwoDescription || "",
            sliderTwoTitle: Sliderdataedit?.sliderTwoTitle || "",
            sliderTwoButtonTitle: Sliderdataedit?.sliderTwoButtonTitle || "",
            sliderTwoImage:Sliderdataedit?.sliderTwoImage || "",
            sliderThreeLink: Sliderdataedit?.sliderThreeLink || "",
            sliderThreeTitle: Sliderdataedit?.sliderThreeTitle || "",
            sliderThreeDescription: Sliderdataedit?.sliderThreeDescription || "",
            sliderThreeButtonTitle: Sliderdataedit?.sliderThreeButtonTitle || "",
            sliderThreeImage:Sliderdataedit?.sliderThreeImage || "",
        },
    })

    useEffect(() => {
        getHomeSliderData();
    }, []);

    const getHomeSliderData = async () => {
        try {
            const response = await HomeSliderService.getHomeSliderData();
            const data = response.sliderData;
            setSliderData(data);
            setValue("sliderOneLink", data.sliderOneLink);
            setValue("sliderOneDescription", data.sliderOneDescription); 
            setValue("sliderOneButtonTitle", data.sliderOneButtonTitle);
            setValue("sliderOneTitle", data.sliderOneTitle);
            setValue("sliderOneImage", data.sliderOneImage);

            setValue("sliderTwoLink", data.sliderTwoLink);
            setValue("sliderTwoDescription", data.sliderTwoDescription); 
            setValue("sliderTwoButtonTitle", data.sliderTwoButtonTitle);
            setValue("sliderTwoTitle", data.sliderTwoTitle);
            setValue("sliderTwoImage", data.sliderTwoImage);

            setValue("sliderThreeLink", data.sliderThreeLink);
            setValue("sliderThreeDescription", data.sliderThreeDescription); 
            setValue("sliderThreeButtonTitle", data.sliderThreeButtonTitle);
            setValue("sliderThreeTitle", data.sliderThreeTitle);
            setValue("sliderThreeImage", data.sliderThreeImage);
        } catch (error) {
            handleApiErrors(error);
        }
    };


    const onSubmit = async (sliderupdateimage) => {

        const updatePrivilege = user?.setPrivileges?.find(
            (priv) => priv.parameter === "Updateslider"
          );
      
          if (updatePrivilege?.update) {
      


        try {
            // Call TestimonialService to add the blog
            const response = await HomeSliderService.updateSliderData(
                sliderupdateimage.sliderOneImage[0],
                sliderupdateimage.sliderOneLink,
                sliderupdateimage.sliderOneTitle,
                sliderupdateimage.sliderOneDescription,
                sliderupdateimage.sliderOneButtonTitle,

                sliderupdateimage.sliderTwoImage[0],
                sliderupdateimage.sliderTwoTitle,
                sliderupdateimage.sliderTwoDescription,
                sliderupdateimage.sliderTwoButtonTitle,
                sliderupdateimage.sliderTwoLink,
                
                sliderupdateimage.sliderThreeImage[0],
                sliderupdateimage.sliderThreeTitle,
                sliderupdateimage.sliderThreeDescription,
                sliderupdateimage.sliderThreeButtonTitle, 
                sliderupdateimage.sliderThreeLink,
             
            );
            toast.success(response.message);

            navigate(RoutesPath.updateSlider);
        } catch (error) {
            handleApiErrors(error);
        }
    }else{
        toast.warning("You don't have permission to update slider.");
    }
    };

    return (
        <div>
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <h1 className="black fs-18 fw-600 mb-0">UPDATE SLIDER</h1>
                <div className="d-flex">
                    <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
                    <h4 className="fs-12 fw-500 primary mb-0">Update Slider</h4>
                </div>
            </div>
            <div className="table_container" style={{ display: "block" }}>
                <div class="row updateslidersection">
                    <div className="table_title col-md-12">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                Slider 1<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6 profile_inputs">
                        <div className="mb-3">
                            <CustomTextField
                                labelTitle="Title"
                                placeholder="Title"
                                name="sliderOneTitle"
                                id="sliderOneTitle"
                                inputType={InputType.text}
                                showMandatory={true}
                                additionalClasses="profile_edit"
                                register={register}
                                //   setValue={setValues}
                                showError={errors?.sliderOneTitle}
                                errorMessage={errors?.sliderOneTitle?.message}
                                defaultValue={sliderData?.sliderOneTitle || ""}
                            />

                        </div>
                        <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderOneImage"
                                id="sliderOneImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.uploadimageone}
                                // // errorMessage={errors?.uploadimageone?.message}
                                defaultValue={sliderData?.sliderOneImage || ""}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 descriptionsection">
                        <div className="col-md-12 mb-3">
                            <CustomTextArea
                                labelTitle="Description"
                                placeholder="Description"
                                name="sliderOneDescription"
                                id="sliderOneDescription"
                                additionalClasses="descriptionbox"
                                inputType={InputType.text}
                                showMandatory={true}
                                register={register}
                                showError={errors?.sliderOneDescription}
                                errorMessage={errors?.sliderOneDescription?.message}
                                defaultValue={sliderData?.sliderOneDescription || ""}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Name"
                            placeholder="Button Name"
                            name="sliderOneButtonTitle"
                            id="sliderOneButtonTitle"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderOneButtonTitle}
                            errorMessage={errors?.sliderOneButtonTitle?.message}
                            defaultValue={sliderData?.sliderOneButtonTitle || ""}
                        />
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Link"
                            placeholder="Button Link"
                            name="sliderOneLink"
                            id="sliderOneLink"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderOneLink}
                            errorMessage={errors?.sliderOneLink?.message}
                            defaultValue={sliderData?.sliderOneLink || ""}
                        />
                    </div>
                    <div className="table_title col-md-12">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                Slider 2<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6 profile_inputs">
                        <div className="mb-3">
                            <CustomTextField
                                labelTitle="Title"
                                placeholder="Title"
                                name="sliderTwoTitle"
                                id="sliderTwoTitle"
                                inputType={InputType.text}
                                showMandatory={true}
                                additionalClasses="profile_edit"
                                register={register}
                                //   setValue={setValues}
                                showError={errors?.sliderTwoTitle}
                                errorMessage={errors?.sliderTwoTitle?.message}
                                defaultValue={sliderData?.sliderTwoTitle || ""}
                            />

                        </div>
                        <div className="">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderTwoImage"
                                id="sliderTwoImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.sliderTwoImage}
                                // errorMessage={errors?.sliderTwoImage?.message}
                                defaultValue={sliderData?.sliderTwoImage || ""}
                            />
                        </div>
                    </div>
                    <div className="col-md-6 descriptionsection">
                        <div className="col-md-12 mb-3">
                            <CustomTextArea
                                labelTitle="Description"
                                placeholder="Description"
                                name="sliderTwoDescription"
                                id="sliderTwoDescription"
                                additionalClasses="descriptionbox"
                                inputType={InputType.text}
                                showMandatory={true}
                                register={register}
                                showError={errors?.sliderTwoDescription}
                                errorMessage={errors?.sliderTwoDescription?.message}
                                defaultValue={sliderData?.sliderTwoDescription || ""}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Name"
                            placeholder="Button Name"
                            name="sliderTwoButtonTitle"
                            id="sliderTwoButtonTitle"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderTwoButtonTitle}
                            errorMessage={errors?.sliderTwoButtonTitle?.message}
                            defaultValue={sliderData?.sliderTwoButtonTitle || ""}
                        />
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Link"
                            placeholder="Button Link"
                            name="sliderTwoLink"
                            id="sliderTwoLink"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderTwoLink}
                            errorMessage={errors?.sliderTwoLink?.message}
                            defaultValue={sliderData?.sliderTwoLink || ""}
                        />
                    </div>
                    <div className="table_title col-md-12">
                        <div className="table_headings">
                            <h1 className="black fs-18 fw-600 mb-0">
                                Slider 3<span className="fs-18 danger">*
                                </span>
                            </h1>
                        </div>
                    </div>
                    <div className="col-md-6 profile_inputs">
                        <div className="mb-3">
                            <CustomTextField
                                labelTitle="Title"
                                placeholder="Title"
                                name="sliderThreeTitle"
                                id="sliderThreeTitle"
                                inputType={InputType.text}
                                showMandatory={true}
                                additionalClasses="profile_edit"
                                register={register}
                                //   setValue={setValues}
                                showError={errors?.sliderThreeTitle}
                                errorMessage={errors?.sliderThreeTitle?.message}
                                defaultValue={sliderData?.sliderThreeTitle || ""}
                            />

                        </div>

                        <div className="col-md-6 col-lg-12">
                            <CustomTextField
                                labelTitle="Upload Image"
                                placeholder="Upload File"
                                name="sliderThreeImage"
                                id="sliderThreeImage"
                                additionalClasses="select_file "
                                inputType={InputType.file}
                                showMandatory={true}
                                register={register}
                                // showError={errors?.sliderThreeImage}
                                // errorMessage={errors?.sliderThreeImage?.message}
                                defaultValue={sliderData?.sliderThreeImage || ""}
                            />
                        </div>


                    </div>
                    <div className="col-md-6 descriptionsection">
                        <div className="mb-3">
                            <CustomTextArea
                                labelTitle="Description"
                                placeholder="Description"
                                name="sliderThreeDescription"
                                id="sliderThreeDescription"
                                additionalClasses="descriptionbox"
                                inputType={InputType.text}
                                showMandatory={true}
                                register={register}
                                showError={errors?.sliderThreeDescription}
                                errorMessage={errors?.sliderThreeDescription?.message}
                                defaultValue={sliderData?.sliderThreeDescription || ""}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Name"
                            placeholder="Button Name"
                            name="sliderThreeButtonTitle"
                            id="sliderThreeButtonTitle"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderThreeButtonTitle}
                            errorMessage={errors?.sliderThreeButtonTitle?.message}
                            defaultValue={sliderData?.sliderThreeButtonTitle || ""}
                        />
                    </div>
                    <div className="col-md-6">
                        <CustomTextField
                            labelTitle="Button Link"
                            placeholder="Button Link"
                            name="sliderThreeLink"
                            id="sliderThreeLink"
                            additionalClasses="profile_edit"
                            inputType={InputType.text}
                            showMandatory={true}
                            register={register}
                            showError={errors?.sliderThreeLink}
                            errorMessage={errors?.sliderThreeLink?.message}
                            defaultValue={sliderData?.sliderThreeLink || ""}
                        />
                    </div>
                    <div className="d-flex justify-content-end mt-3">
                        <ButtonWithIcon
                            text={"Update"}
                            icon={SvgImages.right_arrow}
                            onClick={handleSubmit(onSubmit)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UpdateSlider;
